<template>
  <div class="app-container">
    <div class="components-container">
      <split-pane split="vertical" :min-percent='14' :default-percent='14'>
        <template slot="paneL">
          <div class="grid-content bg-purple">
            <el-scrollbar style="height:calc(100vh - 120px)">
              <el-row style="margin: 10px;border-bottom:1px solid #dedede;padding-bottom:10px">
                <el-col :span="24">
                  <span style="font-size: 14px;color:#666;float:left">产品文档</span>
                  <el-popover placement="top" width="220" trigger="click">
                    <el-input v-model="addtext"></el-input>
                    <div style="text-align: right; margin-top: 10px">
                      <el-button type="primary" size="mini" @click="addcaidan">确定</el-button>
                    </div>
                    <i slot="reference" class="el-icon-circle-plus-outline" style="color:#666;cursor: pointer;float:right;margin-right:7px" title="添加" @click="addtext=''" v-if="isAdmin_Vip"></i>
                  </el-popover>
                  <i class="el-icon-download" v-if="!expandall" @click="expandallclick(true)" style="color:#666;cursor: pointer;float:right;margin-right:10px" title="全部展开"></i>
                  <i class="el-icon-upload2" v-if="expandall" @click="expandallclick(false)" style="color:#666;cursor: pointer;float:right;margin-right:10px" title="全部收起"></i>
                </el-col>
              </el-row>
              <el-tree :data="treedata" node-key="value" ref="eltree1" :props="{children:'child'}" :expand-on-click-node="false" style="background:none" draggable highlight-current @node-click="nodeclick"
                :default-expand-all="expandall">
                <span class="custom-tree-node" style="width:0" slot-scope="{ node, data }">
                  <span style="font-size: 12px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="node.label">{{ node.label }}</span>
                  <span>
                    <el-dropdown trigger="click" @command="dropdowncommand($event,node,data)" :hide-on-click="false" v-if="isAdmin_Vip">
                      <span class="el-dropdown-link">
                        <i class="el-icon-more"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-popover placement="top" width="220" trigger="click">
                          <el-input v-model="addtext"></el-input>
                          <div style="text-align: right; margin-top: 10px">
                            <el-button type="primary" size="mini" @click="addzicaidan">确定</el-button>
                          </div>
                          <el-dropdown-item command="1" slot="reference" icon="el-icon-circle-plus-outline">添加子级</el-dropdown-item>
                        </el-popover>

                        <el-popover placement="top" width="220" trigger="click">
                          <el-input v-model="addtext"></el-input>
                          <div style="text-align: right; margin-top: 10px">
                            <el-button type="primary" size="mini" @click="updatazicaidan">确定</el-button>
                          </div>
                          <el-dropdown-item command="2" slot="reference" icon="el-icon-edit">编辑名称</el-dropdown-item>
                        </el-popover>

                        <el-popover placement="top" width="220" trigger="click">
                          <i class="el-icon-info" style="color:red"></i>
                          <span style="font-size: 14px;color:#666">确定删除此菜单吗？</span>
                          <div style="text-align: right; margin-top: 10px">
                            <el-button type="primary" size="mini" @click="deletezicaidan">确定</el-button>
                          </div>
                          <el-dropdown-item command="3" slot="reference" icon="el-icon-delete">删除</el-dropdown-item>
                        </el-popover>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </template>
        <template slot="paneR">

          <div class="grid-content bg-purple-light"  v-if="!showedit">
            <el-scrollbar  style="height:calc(100vh - 120px)" class="rightsc">
              <div style="width:100%;float:left;" v-if="isAdmin_Vip">
                <el-button icon="el-icon-edit" size="mini" style="float:right;margin:10px" @click="bianjiclick">编辑</el-button>
              </div>
              <div style="width:94%;float:left;padding:0 3%;font-size:12px;text-align: center;color:#666" v-if="contenttext==''">
                <span v-if="isAdmin_Vip">点击编辑添加内容</span>
                <span v-if="!isAdmin_Vip">文档未发布，请联系管理员</span>
              </div>
              <div style="width:94%;float:left;padding:0 3%" class="markdownEditor" v-html="contenttext"></div>
            </el-scrollbar>
          </div>

          <div class="grid-content bg-purple-light" v-if="showedit">
            <el-scrollbar  style="height:calc(100vh - 120px)">
              <div style="width:100%;float:left;">
                <el-button icon="el-icon-circle-check" type="primary" size="mini" style="float:right;margin:10px" @click="baocuntext">保存</el-button>
                <el-button icon="el-icon-circle-close" size="mini" style="float:right;margin:10px" @click="showedit = false">取消</el-button>
              </div>
              <markdown-editor v-model="contenttextedit" mode="wysiwyg" language="zh-CN" height="calc(100vh - 170px)" style="width:98%;margin-left:10px" />
            </el-scrollbar>
          </div>

        </template>
      </split-pane>
    </div>
  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import MarkdownEditor from '@/components/MarkdownEditor'
import { ajax_wikimenulist, ajax_wikimenumerge, ajax_wikimenudelete, ajax_wikiinfo, ajax_wikiinfomerge } from '@Sys~/api/sys'
import { getUserId } from '@Test~/utils/auth' // get token from cookie

export default {
  name:'chanpindoc',
  components: { MarkdownEditor, splitPane },
  data() {
    return {
      allheight: document.documentElement.clientHeight - 120,
      showedit: false,
      expandall: true,
      treedata: [],
      contenttext: "",//显示
      contenttextedit: "",//编辑
      addtext: "",//菜单text
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,
      menuform: {
        id: "",
        title: "",
        pid: 0,
        type:process.env.VUE_APP_PROJECT_TYPE,
        userId: this.$store.getters.userId
      },
      deleteId: "",
      clickId: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    resize() {
      console.log('resize')
    },
    expandallclick(e) {
      this.expandall = e
      this.allexpand(this.treedata, e)
    },

    allexpand(list, bol) {
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          this.$refs.eltree1.store.nodesMap[list[i].value].expanded = bol
          if (list[i].child && list[i].child.length > 0) {
            this.allexpand(list[i].child, bol)
          }
        }
      }
    },
    allhide() {
      var arr = document.getElementsByClassName("el-popover");
      for (var i = 0; i < arr.length; i++) {
        arr[i].style.display = "none";
      }
    },

    addcaidan() {
      this.menuform.id = "";
      this.menuform.pid = 0;
      this.menuform.title = this.addtext;
      ajax_wikimenumerge(this.menuform).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.getList()
          this.allhide();
        } else {
          this.$message.console.error(response.msg)
        }
      });
    },
    addzicaidan() {
      this.menuform.title = this.addtext;
      ajax_wikimenumerge(this.menuform).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.getList()
          this.allhide();
        } else {
          this.$message.console.error(response.msg)
        }
      });
    },
    updatazicaidan() {
      this.menuform.title = this.addtext;
      ajax_wikimenumerge(this.menuform).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.getList()
          this.allhide();
        } else {
          this.$message.console.error(response.msg)
        }
      });
    },
    deletezicaidan() {
      ajax_wikimenudelete(this.deleteId).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.getList()
          this.allhide();
        } else {
          this.$message.console.error(response.msg)
        }
      });
    },
    dropdowncommand(e, v, d) {
      if (e == 1) {
        this.menuform.id = "";
        this.menuform.pid = d.value;
        this.addtext = ""
      } else if (e == 2) {
        this.menuform.id = d.value;
        this.addtext = d.label
      } else if (e == 3) {
        this.deleteId = d.value;
      }
    },
    nodeclick(e) {
      this.clickId = e;
      this.showedit = false;
      ajax_wikiinfo(e.value).then(response => {
        if (response.code == 1) {
          if (response.data && response.data.content != "") {
            this.contenttext = response.data.content;
          } else {
            this.contenttext = "";
          }
        }
      });
    },

    // 获取列表
    getList() {
      ajax_wikimenulist(process.env.VUE_APP_PROJECT_TYPE).then(response => {
        if (response.code == 1) {
          this.treedata = response.data;
          if (this.treedata.length > 0) {
            this.$refs.eltree1.setCurrentKey(this.treedata[0].value)
            this.nodeclick(this.treedata[0])
            this.clickId = this.treedata[0];
          }
        }
      });
    },
    bianjiclick() {
      this.showedit = true;
      this.contenttextedit = this.contenttext;
    },
    baocuntext() {
      var datas = {
        menuId: this.clickId.value,
        content: this.contenttextedit,
        userId: this.$store.getters.userId,
      }
      ajax_wikiinfomerge(datas).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.showedit = false;
          this.nodeclick(this.clickId)
        } else {
          this.$message.console.error(response.msg)
        }
      });
    },
  }
}
</script>


<style  scoped>
.components-container {
  margin: 0px;
  position: relative;
  height: calc(100vh - 120px);
}

</style>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 18px;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-row {
  margin-bottom: 20px;
}
.bg-purple-dark {
  background: #f9fafc;
}
.bg-purple {
  background: #f9fafc;
  border-right: 1px solid #dedede;
}
.bg-purple-light {
  background: #f9fafc;
}
.grid-content {
  min-height: 36px;
}
.markdownEditor table th td{
  border: 1px solid #dedede;
  border-collapse:collapse;
}
.markdownEditor table thead th{
  background:#eeeeee ;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

<style lang="scss" scoped>
.hovertext {
  display: none;
  float: left;
  line-height: 14px;
  font-size: 12px;
}
.hoverbg:hover .hovertext {
  display: block;
}

.dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
  .content {
    margin-bottom: 30px;
    min-height: 200px;
    line-height: 1.5;
  }
}
</style>